
import * as React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface IInfoboxProps {
  placement?: 'left' | 'right'
}

class Infobox extends React.PureComponent<IInfoboxProps> {
  render() {
    const placement = this.props.placement || 'right'
    return (
      <OverlayTrigger
        trigger={['click', 'hover', 'focus']}
        delayHide={1500}
        placement={placement}
        overlay={
        <Tooltip id="savingsContributionsTooltip" className="infobox">{this.props.children}</Tooltip>}>
        <span>&nbsp;<i className="fa fa-fw fa-info-circle" /></span>
      </OverlayTrigger>
    )
  }
}

export {
  Infobox
}



// WEBPACK FOOTER //
// ./src/app/components/Infobox/index.tsx